import Image from 'next/image'
import React, { useEffect } from 'react'

function LifeBenzatineInfotech() {
    useEffect(() => {
        const commonScrollFunction = (selectorClass, speed, direction) => {
            const marquee = document.querySelector(
                `${selectorClass} .marqueex-inner`
            )
            if (!marquee) return

            let scrollAmount =
                direction == -1 ? -marquee.scrollWidth / 2 : 0
            let isHovered = false

            const marqueeContent = marquee.innerHTML
            marquee.innerHTML += marqueeContent

            const startScrolling = () => {
                if (!isHovered) {
                    scrollAmount -= speed * direction
                    if (
                        Math.abs(scrollAmount) >=
                            marquee.scrollWidth / 2 &&
                        direction != -1
                    ) {
                        scrollAmount = 0
                    } else if (scrollAmount >= 0 && direction == -1) {
                        scrollAmount = -marquee.scrollWidth / 2
                    }

                    marquee.style.transform = `translateX(${scrollAmount}px)`
                }
                animationFrameId = requestAnimationFrame(startScrolling)
            }

            let animationFrameId
            const handleMouseOver = () => { isHovered = true }
            const handleMouseOut = () => { isHovered = false }

            marquee.addEventListener('mouseover', handleMouseOver)
            marquee.addEventListener('mouseout', handleMouseOut)

            startScrolling()

            // Cleanup function
            return () => {
                if (animationFrameId) {
                    cancelAnimationFrame(animationFrameId)
                }
                marquee.removeEventListener('mouseover', handleMouseOver)
                marquee.removeEventListener('mouseout', handleMouseOut)
            }
        }

        const cleanup1 = commonScrollFunction('.glider-2', 3, -1)
        const cleanup2 = commonScrollFunction('.glider-1', 3, 1)

        // Cleanup on component unmount
        return () => {
            cleanup1?.()
            cleanup2?.()
        }
    }, []) // Empty dependency array means this effect runs once on mount

    return (
        <section className="section_secondary_bg image_discover_slider">
            <h5>Great workspace motivates for great work!</h5>
            <h2 className="text-center tech_title section_heading_title mb-3">
                Life @Benzatine Infotech
            </h2>
            <p className="section_desc mb-0">
                We work, laugh, celebrate, share experiences, and grow stronger
                together!!!
            </p>
            <div className="d-flex flex-column mt-5">
                <div className="marqueex glider-2">
                    <div className="marqueex-inner">
                        <div className="double-img-container d-flex flex-column">
                            <Image width={250} height={165} src="/assets/image/gallery/s1.jpeg" alt="Gallery Image" />
                            <Image width={250} height={165} src="/assets/image/gallery/s2.png" alt="Gallery Image" />
                        </div>
                        <div className="center-img">
                            <Image width={500} height={350} src="/assets/image/gallery/b1.jpeg" alt="Gallery Image" />
                        </div>
                        <div className="double-img-container d-flex flex-column">
                            <Image width={250} height={165} src="/assets/image/gallery/s3.jpeg" alt="Gallery Image" />
                            <Image width={250} height={165} src="/assets/image/gallery/s4.png" alt="Gallery Image" />
                        </div>
                        <div className="center-img">
                            <Image width={500} height={350} src="/assets/image/gallery/b2.jpeg" alt="Gallery Image" />
                        </div>
                        <div className="double-img-container d-flex flex-column">
                            <Image width={250} height={165} src="/assets/image/gallery/s5.png" alt="Gallery Image" />
                            <Image width={250} height={165} src="/assets/image/gallery/s6.jpeg" alt="Gallery Image" />
                        </div>
                        <div className="center-img">
                            <Image width={500} height={350} src="/assets/image/gallery/b4.jpeg" alt="Gallery Image" />
                        </div>
                        <div className="double-img-container d-flex flex-column">
                            <Image width={250} height={165} src="/assets/image/gallery/s7.jpeg" alt="Gallery Image" />
                            <Image width={250} height={165} src="/assets/image/gallery/s8.png" alt="Gallery Image" />
                        </div>
                        <div className="center-img">
                            <Image width={500} height={350} src="/assets/image/gallery/b6.jpeg" alt="Gallery Image" />
                        </div>
                        <div className="double-img-container d-flex flex-column">
                            <Image width={250} height={165} src="/assets/image/gallery/s9.png" alt="Gallery Image" />
                            <Image width={250} height={165} src="/assets/image/gallery/s10.png" alt="Gallery Image" />
                        </div>
                        <div className="center-img">
                            <Image width={500} height={350} src="/assets/image/gallery/b5.png" alt="Gallery Image" />
                        </div>
                        <div className="double-img-container d-flex flex-column">
                            <Image width={250} height={165} src="/assets/image/gallery/s11.png" alt="Gallery Image" />
                            <Image width={250} height={165} src="/assets/image/gallery/s12.png" alt="Gallery Image" />
                        </div>
                        <div className="center-img">
                            <Image width={500} height={350} src="/assets/image/gallery/b7.jpeg" alt="Gallery Image" />
                        </div>
                    </div>
                </div>
                <div className="marqueex glider-1">
                    <div className="marqueex-inner">
                        <div className="double-img-container d-flex flex-column">
                            <Image width={250} height={165} src="/assets/image/gallery/s13.jpeg" alt="Gallery Image" />
                            <Image width={250} height={165} src="/assets/image/gallery/s14.jpeg" alt="Gallery Image" />
                        </div>
                        <div className="center-img">
                            <Image width={500} height={350} src="/assets/image/gallery/b8.jpeg" alt="Gallery Image" />
                        </div>
                        <div className="double-img-container d-flex flex-column">
                            <Image width={250} height={165} src="/assets/image/gallery/s15.jpeg" alt="Gallery Image" />
                            <Image width={250} height={165} src="/assets/image/gallery/s16.jpeg" alt="Gallery Image" />
                        </div>
                        <div className="center-img">
                            <Image width={500} height={350} src="/assets/image/gallery/b9.png" alt="Gallery Image" />
                        </div>
                        <div className="double-img-container d-flex flex-column">
                            <Image width={250} height={165} src="/assets/image/gallery/s17.jpeg" alt="Gallery Image" />
                            <Image width={250} height={165} src="/assets/image/gallery/s18.png" alt="Gallery Image" />
                        </div>
                        <div className="center-img">
                            <Image width={500} height={350} src="/assets/image/gallery/b10.jpeg" alt="Gallery Image" />
                        </div>
                        <div className="double-img-container d-flex flex-column">
                            <Image width={250} height={165} src="/assets/image/gallery/s20.jpeg" alt="Gallery Image" />
                            <Image width={250} height={165} src="/assets/image/gallery/s19.png" alt="Gallery Image" />
                        </div>
                        <div className="center-img">
                            <Image width={500} height={350} src="/assets/image/gallery/b11.jpeg" alt="Gallery Image" />
                        </div>
                        <div className="double-img-container d-flex flex-column">
                            <Image width={250} height={165} src="/assets/image/gallery/s22.jpeg" alt="Gallery Image" />
                            <Image width={250} height={165} src="/assets/image/gallery/s21.png" alt="Gallery Image" />
                        </div>
                        <div className="center-img">
                            <Image width={500} height={350} src="/assets/image/gallery/b12.png" alt="Gallery Image" />
                        </div>
                        <div className="double-img-container d-flex flex-column">
                            <Image width={250} height={165} src="/assets/image/gallery/s23.jpeg" alt="Gallery Image" />
                            <Image width={250} height={165} src="/assets/image/gallery/s24.jpeg" alt="Gallery Image" />
                        </div>
                        <div className="center-img">
                            <Image width={500} height={350} src="/assets/image/gallery/b13.png" alt="Gallery Image" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default LifeBenzatineInfotech
